import { useCallback } from 'react';

import { useTrackAgentThreadArchived } from '@air/analytics';

import { usePrivateWorkspaceAgentPanelSession } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';
import { usePrivateWorkspaceAgentSessionArchiveMutation } from '~/components/v2/components/workspace/workspace-agent-panel/queries/mutations/usePrivateWorkspaceAgentSessionArchiveMutation';

export const useArchiveWorkspaceAgentTask = () => {
  const { getActiveSessionId, resetSession, workspaceId } = usePrivateWorkspaceAgentPanelSession();
  const { trackAgentThreadArchived } = useTrackAgentThreadArchived();
  const { isPending, mutateAsync, variables } = usePrivateWorkspaceAgentSessionArchiveMutation();

  const archiveTask = useCallback(
    async (sessionId: string) => {
      await mutateAsync({
        agentType: 'workspace',
        sessionId,
        workspaceId,
      });

      trackAgentThreadArchived();

      if (getActiveSessionId() === sessionId) {
        resetSession();
      }
    },
    [getActiveSessionId, mutateAsync, resetSession, trackAgentThreadArchived, workspaceId],
  );

  const isArchivingSession = useCallback(
    (sessionId: string) => isPending && variables?.sessionId === sessionId,
    [isPending, variables?.sessionId],
  );

  return {
    archiveTask,
    isArchivingSession,
  };
};
